import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

const ModalCustom = ({
  className,
  show,
  onHide,
  size,
  centered = false,
  classNameHeader,
  title,
  classNameBody,
  children,
  footer
}) => {
  return (
    <Modal className='modal-backoffice' dialogClassName={className} show={show} onHide={() => onHide()} size={size? size : 'md'} centered={centered}>
      <Modal.Header closeButton className={classNameHeader}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={classNameBody}>{children}</Modal.Body>
      <Modal.Footer className="justify-content-between pt-4 mt-2">{footer}</Modal.Footer>
    </Modal>
  );
};


ModalCustom.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.any,
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  className: PropTypes.string,
  classNameHeader: PropTypes.string,
  classNameBody: PropTypes.string,
  onHide: PropTypes.func,
  size: PropTypes.string,
  centered: PropTypes.bool
};

export default ModalCustom;
